<template>
  <section>
    <form @submit.prevent="handleSubmit" class="form-signin shadow p-3 mb-5 bg-white rounded">
    <h3>Forgot Password</h3>
  
    <div class="input-wrapper mt-3">
     <input type="email" class="frmcontrol focus-ring" v-model="email" placeholder="Email" required/>
    </div>

    <button class="btn btn-primary w-100 py-2 mt-3" type="submit">Recover Password</button>
</form>
  </section>

</template>

<script>
import axios from 'axios';

export default {
 name: 'ForgotPassword',
    data() {
        return {
            email: '',
        }
    },
    methods: {
       async handleSubmit() {
            const response = await axios.post('password-reset/', {
                email: this.email
            });
            console.log(response);
        }
 }
}
</script>

<style scoped>
.btn {
    width: auto;
}
.form-signin {
    width: auto;
    max-width: 330px;
    padding: 15px;
    margin: auto;
    margin-top: 300px;
  }
  
  .form-signin .checkbox {
    font-weight: 400;
  }
  
  .form-signin .form-floating:focus-within {
    z-index: 2;
  }
  
  .form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  
  .form-signin input[type="password"] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .input-wrapper {
        display:inline-block;
        position: relative;
        width: 100%;
    }
    .input-wrapper:after {
        font-family: 'FontAwesome';
        content: '\f0e0';
        position: absolute;
        color: grey;
        right: 6px;
        font-size: 18px;
        top: 6px;
    }

    .frmcontrol {
      width: 100%;
      border-radius: 6px;
      height: 40px;
      margin-bottom: 20px;
      padding-inline-start: 15px;

    }
</style>